export default {
  label: 'Send til',
  counter: '{{current}} af {{max}}',
  default_badge: 'Standard',
  remove: 'Fjern {{email}}',
  add_back: 'Tilføj igen',
  empty: 'Tilføj mindst én e-mail.',
  add_label: 'Tilføj en e-mail',
  placeholder: 'navn@eksempel.dk',
  add: 'Tilføj',
  hint: 'Op til {{max}} e-mails. Hver får sin egen e-mail.',
  hint_full: 'Det er det maksimale antal på listen. Fjern en e-mail for at tilføje en anden.',
  errors: {
    full: 'Du kan tilføje højst {{max}} e-mailadresser.',
    invalid: 'Angiv en e-mail som navn@eksempel.dk.',
    duplicate: '{{email}} er allerede på listen.',
  },
};
